<template>
    <div id="page-user-list" class="margin-top-widget">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <span class="font-bold" style="font-size:2.2rem">{{isUpdate ? 'Cập nhật widget' : 'Thêm mới widget'}}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-2">
                    <quill-editor id="editor" v-model="fromData.editorContent" ></quill-editor>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                        <vs-button class="ml-auto mt-2 text-size" @click="saveChanges" :disabled ="!validateForm">{{`${isUpdate ?
                        $t('adminWs.update'): $t('adminWs.create')}`}}
                        </vs-button>
                        <vs-button class="ml-4 mt-2 text-size" type="border" color="warning" @click="$router.go(-1)">{{$t('adminWs.back')}}
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/quill/2.0.0-dev.3/quill.min.js" type="text/javascript"></script>

<script>
import 'quill/dist/quill.snow.css';
import {quillEditor} from 'vue-quill-editor'
export default {   
    components: {
        quillEditor
    },
    data(){
        return {
            fromData: {},
            isUpdate: false
        }
    },
    computed: {
        validateForm(){
            return !this.errors.any();
        }
    },
    methods: {
        endcodeHTML: function(str){
            var encodedStr = str.replace(/[\u00A0-\u9999<>\&]/g, function(i) {
                return '&#'+i.charCodeAt(0)+';';
            })
            return encodedStr;
        },
        saveChanges: function(){
            this.$vs.loading();
            if (!this.fromData.editorContent || this.fromData.editorContent.length < 0) {
                return this.$vs.notify({
                    text:'Chưa nhập dữ liệu',
                    icon:'icon-alert-circle',
                    color:'danger',
                    iconPack:'feather'
                })
            }
            this.fromData.editorContent = this.fromData.editorContent.replaceAll('"', "'");
            let path = this.isUpdate ? '/widget/update' : '/widget/create';
            this.$processor.post(path, this.fromData).then(() => {
                this.$router.push('/admin/widget');
                this.$vs.notify({
                    text: this.isUpdate ? this.$t('widget.create') : this.$t('widget.update'),
                    icon:'icon-alert-circle',
                    color:'primary',
                    iconPack:'feather'
                })
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getWidgetById: function(){
            let id = this.$route.query.id;
            if (id) {
                this.$processor.post(`/widget/find-widget/${id}`).then((res) => {
                    this.fromData = res.data;
                    this.isUpdate = true;
                })
            }
        },
        initScreen(){
            this.getWidgetById();
        }
    },
    created(){
        this.initScreen();
    }
}
</script>

<style>

</style>